/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SyncInstallmentDetailPayloadDto } from './SyncInstallmentDetailPayloadDto';
import {
    SyncInstallmentDetailPayloadDtoFromJSON,
    SyncInstallmentDetailPayloadDtoFromJSONTyped,
    SyncInstallmentDetailPayloadDtoToJSON,
    SyncInstallmentDetailPayloadDtoToJSONTyped,
} from './SyncInstallmentDetailPayloadDto';
import type { SyncDeclarationDetailPayloadDto } from './SyncDeclarationDetailPayloadDto';
import {
    SyncDeclarationDetailPayloadDtoFromJSON,
    SyncDeclarationDetailPayloadDtoFromJSONTyped,
    SyncDeclarationDetailPayloadDtoToJSON,
    SyncDeclarationDetailPayloadDtoToJSONTyped,
} from './SyncDeclarationDetailPayloadDto';
import type { UpdateContractPayloadDto } from './UpdateContractPayloadDto';
import {
    UpdateContractPayloadDtoFromJSON,
    UpdateContractPayloadDtoFromJSONTyped,
    UpdateContractPayloadDtoToJSON,
    UpdateContractPayloadDtoToJSONTyped,
} from './UpdateContractPayloadDto';

/**
 * 
 * @export
 * @interface BindOrCloseContractPayloadDto
 */
export interface BindOrCloseContractPayloadDto {
    /**
     * 
     * @type {UpdateContractPayloadDto}
     * @memberof BindOrCloseContractPayloadDto
     */
    contractPayload: UpdateContractPayloadDto;
    /**
     * 
     * @type {Array<SyncInstallmentDetailPayloadDto>}
     * @memberof BindOrCloseContractPayloadDto
     */
    installmentDetails?: Array<SyncInstallmentDetailPayloadDto>;
    /**
     * 
     * @type {Array<SyncDeclarationDetailPayloadDto>}
     * @memberof BindOrCloseContractPayloadDto
     */
    declarationDetails?: Array<SyncDeclarationDetailPayloadDto>;
}

/**
 * Check if a given object implements the BindOrCloseContractPayloadDto interface.
 */
export function instanceOfBindOrCloseContractPayloadDto(value: object): value is BindOrCloseContractPayloadDto {
    if (!('contractPayload' in value) || value['contractPayload'] === undefined) return false;
    return true;
}

export function BindOrCloseContractPayloadDtoFromJSON(json: any): BindOrCloseContractPayloadDto {
    return BindOrCloseContractPayloadDtoFromJSONTyped(json, false);
}

export function BindOrCloseContractPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BindOrCloseContractPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contractPayload': UpdateContractPayloadDtoFromJSON(json['contractPayload']),
        'installmentDetails': json['installmentDetails'] == null ? undefined : ((json['installmentDetails'] as Array<any>).map(SyncInstallmentDetailPayloadDtoFromJSON)),
        'declarationDetails': json['declarationDetails'] == null ? undefined : ((json['declarationDetails'] as Array<any>).map(SyncDeclarationDetailPayloadDtoFromJSON)),
    };
}

export function BindOrCloseContractPayloadDtoToJSON(json: any): BindOrCloseContractPayloadDto {
    return BindOrCloseContractPayloadDtoToJSONTyped(json, false);
}

export function BindOrCloseContractPayloadDtoToJSONTyped(value?: BindOrCloseContractPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contractPayload': UpdateContractPayloadDtoToJSON(value['contractPayload']),
        'installmentDetails': value['installmentDetails'] == null ? undefined : ((value['installmentDetails'] as Array<any>).map(SyncInstallmentDetailPayloadDtoToJSON)),
        'declarationDetails': value['declarationDetails'] == null ? undefined : ((value['declarationDetails'] as Array<any>).map(SyncDeclarationDetailPayloadDtoToJSON)),
    };
}

